import { environment } from 'src/environments/environment';

export function esUsuarioInstitucional(
    email: string | null | undefined
): boolean {
    if (!email) {
        return false;
    }

    const emailNormalizado = email.trim().toLowerCase();
    return environment.dominiosInstitucionales.some((dominio) =>
        emailNormalizado.endsWith(dominio.toLowerCase())
    );
}
